import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseSearchForm } from '@shared/ui/base-search-form';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { UiColumn } from '@shared/ui/ui-column';
import { TextAreaControl } from '@shared/ui/controls/textarea-control.model';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { ToggleControl } from '../../../shared/ui/controls/toggle-control.model';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { ItemSearchResult } from '@shared/interfaces/gridrows/item-search-result.interface';
import { SearchGridComponent } from '../../../shared/components/grid/search-grid.component';
import { ToolBarComponent } from '@progress/kendo-angular-toolbar';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { SecurityRole } from '../../../shared/literals/shared.literal';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { VisibleProperty } from '../../../shared/ui/control-options/control-option.interface';
import { BundleSearchResult } from '../../../shared/interfaces/gridrows/bundle-search-result.interface';
import { Permission } from '../../../core/literals/permission.literal';
import { CountrySelect } from '../../../shared/ui/select-controls/country-select.model';
import { CountryFilter } from '../../../shared/interfaces/select-filters/country-filter.interface';

@Component({
    selector: 'app-bundle-list',
    templateUrl: './bundle-list.component.html',
    styleUrls: ['./bundle-list.component.css'],
    standalone: false
})
export class BundleListComponent extends BaseSearchForm<BundleSearchResult> implements OnInit {

  @ViewChild('toolbar') bar: ToolBarComponent;

  organizationId: Number | null;

  canCreateBundles: boolean;

  showSearchToolButtons: boolean;

  @Input() items: ToolbarItem[];

  ngOnInit(): void {

    var session = this.auth.getSession();

    this.canCreateBundles = (this.auth.canPerformAction(Permission.CreateUpdateBundles));
    this.showSearchToolButtons = this.canCreateBundles;

    this.organizationId = Number(session?.organizationId);

    var toolbarAddNew: ToolbarItem = {
      text: 'Add Bundle',
      icon: faPlus,
      hasMultiple: false,
      cssClass: 'success',
      action: () => { this.redirectToNewBundle(); }
    };

    if (this.canCreateBundles == true) {
      this.toolbarItems.unshift(toolbarAddNew);
    }
  }
  constructor(private router: Router, private auth: AuthenticationService) {
    super();
    this.name = "Bundle";
    this.apiController = "Bundle";
    this.keyFieldName = "id";
    this.canFilterSearch = this.auth.isAdmin();

    this.initializeUiControls();
    this.setGridSettings();
  }
  override initializeUiControls() {

    var session = this.auth.getSession();

    const view = new ViewControl("");

    const search = new UiGroupControl("", "Search");
    const isInStock = new ToggleControl("isInStock", "Is In Stock?", true);
    const isActive = new ToggleControl("isActive", "Is Active?", true);

    const countrySelect = new CountrySelect("countryIds", "Country", session?.countryList);

    var countryFilter: CountryFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    countrySelect.filters = countryFilter;

    const name = new TextControl("name", "Name", "");

    var row = new ViewRowControl();
    row.controls.push(isActive, isInStock, name, countrySelect);

    search.rows.push(row);
    view.controls.push(search);

    this.views.push(view);
  }

  setGridSettings(): void {
    this.gridSettings = {
      gridName: "BundleSearch_Grid",
      preloadData: true,
      columns: this.getColumns(),
      showSubGrid: true,
      subGridColumns: this.getSubGridColumns(),
      subGridDataProperty: "itemBundles"
    };
  }

  private getSubGridColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var sku = new UiColumn("item_Name", "SKU", 60);
    var title = new UiColumn("item_Title", "Title", 160);
    var quantity = new UiColumn("quantity", "Quantity", 30);

    cols.push(sku, title, quantity);

    return cols;
  }

  private getColumns(): UiColumn[] {
    let cols: UiColumn[] = [];

    var name = new UiColumn("name", "Bundle", 100);
    var country = new UiColumn("country", "Country", 100);
    var isActive = new UiColumn("isActive", "Is Active?", 100, true, "boolean");

    cols.push(name, country, isActive);

    return cols;
  }

  public redirectToNewBundle() {
    this.router.navigate(['/Bundle/Detail/0']);
  }
}
